import { render } from "./TheProfessionalConsultationScroll.vue?vue&type=template&id=75ba166e&scoped=true&ts=true"
import script from "./TheProfessionalConsultationScroll.vue?vue&type=script&lang=ts"
export * from "./TheProfessionalConsultationScroll.vue?vue&type=script&lang=ts"

import "./TheProfessionalConsultationScroll.vue?vue&type=style&index=0&id=75ba166e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75ba166e"]])

export default __exports__